import { z } from 'zod';

export const JobStatusEnumSchema = z.enum(['Completed', 'Failed', 'Pending']);
export const UpdateJobStatusEnumSchema = JobStatusEnumSchema.exclude([
  'Pending',
]);

export const JobDetailsSchema = z.object({
  id: z.string(),
  accureId: z.string(),
  chargeStartTime: z.coerce.date(),
  chargeEndTime: z.coerce.date(),
  dischargeStartTime: z.coerce.date(),
  dischargeEndTime: z.coerce.date(),
  status: JobStatusEnumSchema,
  createdAt: z.coerce.date(),
  finishedAt: z.coerce.date(),
  createdBy: z.string(),
});

export const JobPreviewSchema = JobDetailsSchema.pick({
  id: true,
  status: true,
  createdAt: true,
  chargeStartTime: true,
  chargeEndTime: true,
  dischargeStartTime: true,
  dischargeEndTime: true,
}).merge(
  z.object({
    sohc: z.number(),
    dischargedEnergy: z.number(),
  }),
);

export const JobResultSchema = z.object({
  id: z.string(),
  fullFrontendId: z.string(),
  chargingEnergy: z.number(),
  dischargingEnergy: z.number(),
  chargingSohC: z.number(),
  dischargingSohC: z.number(),
});

export const UpdateJobStatusRequestSchema = z.object({
  status: UpdateJobStatusEnumSchema,
});

export const CreateJobRequestSchema = z.object({
  assetId: z.string(),
  chargeStartTime: z.coerce.date(),
  chargeEndTime: z.coerce.date(),
  dischargeStartTime: z.coerce.date(),
  dischargeEndTime: z.coerce.date(),
  chargeEnergy: z.number().optional(),
  chargePower: z.number().optional(),
  dischargeEnergy: z.number().optional(),
  dischargePower: z.number().optional(),
});

export const CreateJobOutputSchema = z.object({
  id: z.string(),
});

export const SiteSohSchema = z.object({
  year: z.number(),
  month: z.number(),
  avgSohC: z.number(),
});

export type JobStatus = z.infer<typeof JobStatusEnumSchema>;
export type UpdateJobStatus = z.infer<typeof UpdateJobStatusEnumSchema>;
export type JobDetails = z.infer<typeof JobDetailsSchema>;
export type JobPreview = z.infer<typeof JobPreviewSchema>;
export type JobResult = z.infer<typeof JobResultSchema>;
export type UpdateJobStatusRequest = z.infer<
  typeof UpdateJobStatusRequestSchema
>;
export type CreateJobRequest = z.infer<typeof CreateJobRequestSchema>;
export type CreateJobOutput = z.infer<typeof CreateJobOutputSchema>;
export type SiteSoh = z.infer<typeof SiteSohSchema>;
